import { Text } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';
import type { Client } from 'src/admin/users/types';
import { buildClientSummary } from 'src/meetings/utils/build-client-summary';
import useDynamicNonFinancialData from 'src/non-financial-data/hooks/useDynamicNonFinancialData';

type Props = {
  client: Client;
};

export const ClientInfoText = ({ client }: Props) => {
  const { nonFinancialData } = useDynamicNonFinancialData(client.id);

  if (!nonFinancialData) {
    return null;
  }

  const text = buildClientSummary(nonFinancialData.entities);

  return (
    <Text size="sm" fw={FONT_WEIGHTS.medium} c="gray.10" mb="lg">
      {text}
    </Text>
  );
};
